import type { Department } from "@wwrp/shared";
import { api } from "./client.js";

/** Read-only department choices used by member and DA records. */
export const departmentsApi = {
  list: () => api.get<Department[]>("/departments"),
};
